import React from 'react'
import RoomSchedule from 'frontend/schedule/room-schedule'
import CommonIcons from 'frontend/components/common-icons'

export default class JumanjiSchedule extends RoomSchedule {
  renderHelpers () {
    return (
      <div className="helpers">
        <div className="no_strangers_notice">
          <CommonIcons item="common-user-secret" className="icon" />
          *All games are private, only your team is allowed in the room, &nbsp;
          <span className="color_text">NO strangers</span>.
        </div>

        <div className="legend_with_calendar">
          <div className="blue_price">
            <CommonIcons item="common-calendar-alt-r" className="icon" />
            <div className="type_label">Monday - Thursday</div>
            <div className="price_label">from $45&nbsp;per/person</div>
          </div>
          <div className="green_price">
            <CommonIcons item="common-calendar-alt-r" className="icon" />
            <div className="type_label">Friday - Sunday</div>
            <div className="price_label">from $52&nbsp;per/person</div>
          </div>
        </div>
      </div>
    )
  }
}
